<template lang="html">
  <div>
    <NavBar class="nav" />
    <UserLoader />
    <DetailLoader
      v-if="$store.state.userLoaded"
      :id="this.$route.params.id"
      :key="this.$route.params.id"
    />
    <Import v-if="$store.state.currentShowId && this.$route.name == 'import'" />
    <Editor v-if="$store.state.currentShowId && this.$route.name == 'edit'" />
    <ObjectPrint
      :data="$store.state.currentShowDetails"
      title="currentShowDetails"
    />
  </div>
</template>

<script>
import DetailLoader from "@/components/Editor/loaders/DetailLoader";
import UserLoader from "@/components/Editor/loaders/UserLoader";
import Import from "@/components/Editor/Import";
import NavBar from "@/components/Editor/NavBar";
import ObjectPrint from "@/components/ObjectPrint";
import Editor from "@/components/Editor/Editor";
export default {
  name: "Detail",
  components: {
    DetailLoader,
    UserLoader,
    Import,
    NavBar,
    ObjectPrint,
    Editor
  }
};
</script>

<style lang="scss" scoped></style>
